import { Page } from "@hyperobjekt/material-ui-website"

export default Page
